module.exports = __webpack_public_path__ + "static/media/dark_logo.a93f4211.svg";